
/*
12991	annex
12990   media
12989	ecl
12240   dpl
12207	willis

1.0: https://calendar.library.unt.edu/api/1.0/hours/12207,12990,12989,12240?key=8fb13b2978ace62120c2afa1721b54dc
1.1: https://calendar.library.unt.edu/api/1.1/hours/12207,12990,12989,12240?&from=2020-08-4&to=2020-09-23
1.1 Key: 309f0c09d8ef1de501f143d317dad830

*/

$(() => {
  const libCalHoursPath = "https://calendar.library.unt.edu/api/1.0/hours/12207,12989,12240,20469?key=8fb13b2978ace62120c2afa1721b54dc";
  const now = dayjs();
  const nowFormatted = now.format('YYYY-MM-DD');
  const nowWeekday = now.format('dddd');
  const $buildingHours = $('#building-hours');


	$.when($.getJSON(libCalHoursPath)).done((data) => {
		window.piss = data;

		let elems = "",
		    briefs = [];


		$.each(data, function(i, el) {

		    let colorClass,
		        dateString,
		        name = el.name,
		        lid = el.lid,
		        url = el.url,
		        path = url.substring(23),
		        dates = el.dates,
		        currentDay = dates[nowFormatted],
		        //status = currentDay.status || "call for hours",
		        status = (typeof currentDay === 'undefined') ? "call for hours" : currentDay.status,
		        opens,
		        closes,
		        entry,
		        short = {};

			

	    if (currentDay != undefined){
	    	opens = (typeof currentDay.hours === 'undefined') ? "" : currentDay.hours[0].from;
	    	closes = (typeof currentDay.hours === 'undefined') ? "" : currentDay.hours[0].to;
	      //opens = currentDay.hours[0].from || "";
	      //closes = currentDay.hours[0].to || "";
	    } else {
				opens = "";
	      closes = "";
	    }
			if ( i === 0 || i % 2 === 0 ) {
				colorClass = "bg-light";
			} else {
				colorClass = "bg-white";
			}


			switch(status){
				case "closed":
					dateString = "closed";
					break;
				case "open":

					if (opens != "" && closes == ""){
						dateString = "opens " + opens;
					}
					if (opens == "" && closes != ""){
						dateString = "closes " + closes;
					}
					if (opens != "" && closes != ""){
						dateString = opens + " - " + closes;
					}
					if (opens == "" && closes != ""){
						dateString = "call for hours";
					}
					break;
				case "24hours":
					dateString = "open 24 hours";
					break;
				case "ByApp":
					dateString = "by appointment";
					break;
				default: 
					dateString = status || "call for hours";
			}

			entry = `<div class="d-flex w-100 justify-content-between py-3 px-2 ${colorClass}">
							<a href="${path}"
								   data-ga-event-category="link - home"
								   data-ga-event-action="hours"
								   data-ga-event-label="${name}">${name}</a>
							<div class="hours-info text-left" id="${name}-todays-hours">
								${dateString}
							</div>
						  </div>`;
			elems += entry;

			short.lid = lid;
			short.time = dateString;
			briefs.push(short);
		});
		if ( $buildingHours.hasClass("aggregate") ) {
			$buildingHours.append(elems);
		}

		if ($("#building-hours span.single").length) {
			let $currentLid = $("#building-hours span.single");
			$.each(briefs, function(i, el) {
				console.log(el);
				if ( el.lid === $currentLid.data("lid") ){
					$currentLid.text(el.time);
					return false;
				}
			});
		}

		//console.log(briefs);
	});
});